import { render, staticRenderFns } from "./booking-jobs.vue?vue&type=template&id=6f71bfbc&"
import script from "./booking-jobs.vue?vue&type=script&lang=js&"
export * from "./booking-jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports